module.exports = __webpack_public_path__ + "static/media/2021_HK8A0075.c604425c.jpg";